var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0517 24.695L34.19 31.8317L31.8317 34.19L24.695 27.0517C22.0396 29.1804 18.7367 30.3382 15.3333 30.3334C7.05334 30.3334 0.333344 23.6134 0.333344 15.3334C0.333344 7.05337 7.05334 0.333374 15.3333 0.333374C23.6133 0.333374 30.3333 7.05337 30.3333 15.3334C30.3382 18.7367 29.1804 22.0396 27.0517 24.695ZM23.7083 23.4584C25.8235 21.2832 27.0048 18.3674 27 15.3334C27 8.88671 21.7783 3.66671 15.3333 3.66671C8.88668 3.66671 3.66668 8.88671 3.66668 15.3334C3.66668 21.7784 8.88668 27 15.3333 27C18.3674 27.0048 21.2832 25.8236 23.4583 23.7084L23.7083 23.4584Z",
    fill: "#8D0000"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.9aff870d701399482bf4a5a40798d74a.svg";